import { createSlice } from "@reduxjs/toolkit";

const whatsappChat = createSlice({
  name: "whatsapp-chat",
  initialState: {
    byContact: {},
  },
  reducers: {
    // Load initial batch
    setMessages(state, action) {
      const { contactId, messages } = action.payload;
      state.byContact[contactId] = messages;
    },
    // A new incoming message
    addMessage(state, action) {
      const { contactId, message } = action.payload;
      state.byContact[contactId] = state.byContact[contactId] || [];
      state.byContact[contactId].push(message);
    },
    // Insert older messages at the front
    prependMessages(state, action) {
      const { contactId, messages } = action.payload;
      const existing = state.byContact[contactId] || [];
      state.byContact[contactId] = messages.concat(existing);
    },
    // Status update for an existing message
    updateMessageStatus(state, action) {
      const { contactId, messageId, status } = action.payload;
      const msgs = state.byContact[contactId] || [];
      const msg = msgs.find((m) => m.message_id === messageId);
      if (msg) msg.status = status;
    },
  },
});

export const { setMessages, addMessage, prependMessages, updateMessageStatus } =
  whatsappChat.actions;
export default whatsappChat.reducer;
